import { render, staticRenderFns } from "./SwitchBox.vue?vue&type=template&id=50a1420c&scoped=true&"
import script from "./SwitchBox.vue?vue&type=script&lang=ts&"
export * from "./SwitchBox.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchBox.vue?vue&type=style&index=0&id=50a1420c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a1420c",
  null
  
)

export default component.exports